<script setup lang="ts">
import { useHttpClient } from "@/vf"

const props = defineProps<{
    organizationId: string
    taskId: string
}>()

const http = useHttpClient()

type SimilarOrganization = { name: string; aliases?: []; similarity: number; address: string }
const similarOrganizations: SimilarOrganization[] = (
    await http.get<SimilarOrganization[]>(`/organization/${props.organizationId}/similar-organizations/${props.taskId}`)
).data
</script>
<template>
    <div v-if="similarOrganizations.length > 0">
        <dt>{{ $t("@tasks:tasks.accept_organization_request.possible_doubles") }}</dt>
        <dd>
            <table class="table table-sm table-transparent table-borderless">
                <tr v-for="(similarOrganization, index) in similarOrganizations" :key="index">
                    <td class="pl-0">
                        {{ similarOrganization.name }}
                        <span v-if="similarOrganization.aliases && similarOrganization.aliases?.length > 0">
                            ({{ similarOrganization.aliases.join(", ") }})
                        </span>
                    </td>
                    <td>
                        {{ similarOrganization.address }}
                    </td>
                </tr>
            </table>
        </dd>
    </div>
</template>
